/* main js */
import {Modal, Tabs} from "bootstrap";
import scrollHandler from "./scrollHandler";
import "./swiper"
import scrollObserver from "./scrollObserver";
import {startPageOnTop} from "./utilities";

window.addEventListener('DOMContentLoaded', () => {
    startPageOnTop();
    scrollHandler();

    const isInViewportItems = document.querySelectorAll('.is-in-viewport');
    if (isInViewportItems?.length) {
        scrollObserver({ items: isInViewportItems });
    }

    const heroHomeItems = document.querySelectorAll('.hero-home');
    if (heroHomeItems?.length) {
        scrollObserver({ items : heroHomeItems, rootMargin: "150px 0px" })
    }

    const hasFillAnimationItems = document.querySelectorAll('.has-fill-animation');
    if (hasFillAnimationItems?.length) {
        scrollObserver({ items : hasFillAnimationItems, rootMargin: "150px 0px", threshold: 0 })
    }

    document.querySelector('.navbar-toggler').addEventListener('click', function () {
        document.querySelector('.navbar-toggler-icon').classList.toggle('close');
    });

    const wpcf7FormReplaceSubmit = document.querySelector('.wpcf7-form-replace-submit');
    const wpcf7Form = document.querySelector('.wpcf7-form');
    if (wpcf7FormReplaceSubmit && wpcf7Form) {
        wpcf7FormReplaceSubmit.addEventListener('click', () => wpcf7Form.submit());
    }
})


//versione solo icona del btn-arrow. Qui si toglie lo span .btn-arrow__label, poi in admin aggiungere anche le classi border-0 e p-0
document.querySelectorAll('.btn-arrow__label').forEach(label => {
    if (!label.textContent.trim()) {
        label.remove();
    }
});


//animazione company cards
document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.animate-card__company');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                // Delay animazione per ogni card
                entry.target.style.transitionDelay = `${index * 0.2}s`;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    cards.forEach(card => observer.observe(card));
});


//animazione icon cards (competenze)
document.addEventListener("DOMContentLoaded", () => {
    const iconCards = document.querySelectorAll('.icon-card');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, { threshold: 0.1 });

    iconCards.forEach((card, index) => {
        if (index % 2 === 1) {
            card.classList.add('animate-icon-card');
            observer.observe(card);
        }
    });
});


//animazione zoom out immagine
document.addEventListener('DOMContentLoaded', () => {
    const heroSection = document.querySelector('.hero--zoomout');

    if (heroSection) {
        setTimeout(() => {
            heroSection.classList.add('loaded');
        });
    }
});

